import { defineStore } from 'pinia'
import investorService from '@/services/investor.service'
import localstorageService from '@/core/localstorage.service'
import {
  CANTIRO_CAPITAL,
  MOSKOWITZ_CAPITAL,
  NUMUS_CAPITAL,
  PRESTIGE_CAPITAL,
  RICHMON_EQUITY,
  WALTON_GLOBAL,
  WESTBORO,
  SIGMA2_FAMILY_OFFICE_INC
} from '@/core/companies'

export const useInvestorStore = defineStore('investor', {
  state: () => ({
    investors: null,
    currentInvestor: null,
    offerings: []
  }),

  getters: {
    isRichmondEquity: state => state.currentInvestor?.company_id === RICHMON_EQUITY,
    isNumusCapital: state => state.currentInvestor?.company_id === NUMUS_CAPITAL,
    isWalton: state => state.currentInvestor?.company_id === WALTON_GLOBAL,
    isCantiroCapital: state => state.currentInvestor?.company_id === CANTIRO_CAPITAL,
    isMoskowitzCapital: state => state.currentInvestor?.company_id === MOSKOWITZ_CAPITAL,
    isPrestigeCapital: state => state.currentInvestor?.company_id === PRESTIGE_CAPITAL,
    isWestboro: state => state.currentInvestor?.company_id === WESTBORO,
    isSigma2FamilyOfficeInc: state => state.currentInvestor?.company_id === SIGMA2_FAMILY_OFFICE_INC
  },

  actions: {
    setInvestors (value) {
      this.investors = value
    },

    setCurrentInvestor (value) {
      this.currentInvestor = value
      localstorageService.setItem('currentInvestor', { id: value.id })
    },

    setOfferings (value) {
      this.offerings = value
    },

    async updateInvestor (data) {
      try {
        const res = await investorService.updateInvestor(data)
        this.setCurrentInvestor(data)
        return res
      } catch (err) {
        return Promise.reject(err)
      }
    }
  }
})
